// custom-stepper.js
import React from "react";
import PropTypes from "prop-types";
import { Stepper, Step, StepLabel, CircularProgress, Box } from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";

const CustomStepper = ({ steps, activeStep }) => {
  return (
    <Stepper activeStep={activeStep} orientation="vertical">
      {steps.map((label, index) => (
        <Step key={label}>
          <StepLabel
            icon={
              index < activeStep ? (
                <CheckCircleIcon color="primary" />
              ) : index === activeStep ? (
                <CircularProgress size={24} />
              ) : (
                <RadioButtonUncheckedIcon />
              )
            }
          >
            {label}
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
};

CustomStepper.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.string).isRequired,
  activeStep: PropTypes.number.isRequired,
};

export default CustomStepper;
